
import { defineComponent, PropType } from "vue";
import { Button, ButtonGroup } from "@progress/kendo-vue-buttons";
import { Insight } from "@/models/insight";
import { Observation } from "@/store/reports/models";
import { ObservationStatus } from "./observation-status";
import { useI18n } from "vue-i18n";
import { mapState } from "vuex";

export default defineComponent({
  name: "SingleSelect",
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  data() {
    return {
      selected: this.prefill,
      ObservationStatus,
    };
  },
  computed: {
    ...mapState(["currentSlide"]),
  },
  props: {
    insight: {
      type: Object as PropType<Insight>,
    },
    prefill: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    kbutton: Button,
    buttongroup: ButtonGroup,
  },
  methods: {
    handleSelection($event: any) {
      let targetElement = $event.target;
      if (targetElement.nodeName === "SPAN") {
        targetElement = targetElement.parentElement;
      }
      const value = targetElement.value;
      if (this.selected === value) {
        this.selected = null;
      } else {
        this.selected = value;
      }
      let observation: Observation = {
        key: this.insight.key,
        title: this.t(`config.insight.slide.${this.currentSlide.tissueType}.${this.currentSlide.stain}.${this.insight.key}.title`),
        value: this.selected,
      };
      this.$emit("observationChange", observation);
    },
  },
  watch: {
    prefill(newVal, oldVal) {
      this.selected = newVal;
    },
  },
});
